import { URL } from 'api/constants';
import { apiInstance } from 'api/instance';

export const chiefComplaintsCategories = () =>
  apiInstance.get(URL.GET_CHIEF_COMPLAINTS_MASTER_LIST);

export const getStateData = () => apiInstance.get(URL.GET_STATES_MASTER_LIST);
